@import '../../vars.css';

.clearIcon {
    color: var(--color-light-neutral-translucent-500-inverted);

    &:hover {
        color: var(--color-light-neutral-translucent-500-inverted-hover);
    }

    &:active {
        color: var(--color-light-neutral-translucent-500-inverted-press);
    }
}
